import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './slices';

export const store = configureStore({
	reducer: rootReducer,
	devTools: true,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore non-serializable values from DTE/file workflows
				// (AxiosHeaders, Blob for PDF, FormData for uploads)
				ignoredActions: [
					'warehouseGuide/createDTE/fulfilled',
					'warehouseGuide/readDTEFacele/fulfilled',
					'fileManager/uploadFoldersFile/fulfilled',
					'fileManager/getFileTypeByCode/fulfilled',
				],
				ignoredPaths: [
					'WarehouseGuide.createdDTE.headers',
					'WarehouseGuide.dteFacele.data',
				],
			},
		}),
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<Provider store={store}>
		<React.Fragment>
			<BrowserRouter
				basename={process.env.PUBLIC_URL}
				future={{
					v7_startTransition: true,
					v7_relativeSplatPath: true,
				}}
			>
				<App />
			</BrowserRouter>
		</React.Fragment>
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
